import ViewLink from "@/views/asset-bank/components/ViewLink.vue";
import ViewFile from "@/views/asset-bank/components/ViewFile.vue";
import ViewImage from "@/views/asset-bank/components/ViewImage.vue";
import ViewNotes from "@/views/asset-bank/components/ViewNotes.vue";
import { postAsset } from "@/views/asset-bank/api-client/assets";
import Shimmer from "@/views/asset-bank/components/AssetBankShimmer.vue";
import DeleteModal from "@/components/Modal/DeleteModal.vue";
import { required, requiredIf, helpers } from "vuelidate/lib/validators";
import toast from "@/mixins/toast";
import helper from "@/utils/helper";
import { maxLength } from "vuelidate/lib/validators";
export default {
	mixins: [helper, toast],
	props: {
		assets: Array,
		showlazyLoading: Boolean,
		loaderStatus: Boolean,
		searchQuery: String,
		selectedTab: Number,
	},
	data() {
		return {
			modalName: "",
			acceptedVideoTypes: ["mp4", "mov", "webm"],
			showLoader: false,
			selectedAssetID: null,
			assetThumbnail: null,
			thumbnailPresent: false,
			showDelete: false,
			hideView: false,
			errorFile: false,
			fileObject: null,
			editedIndex: null,
			editNotes: false,
			viewNotes: false,
			viewLink: false,
			editImage: false,
			viewImage: false,
			viewFile: false,
			editFile: false,
			editAsset: false,
			showDetails: {
				title: "",
				tags: [],
				asset: "",
				file: null,
				notes: "",
				link: "",
			},
			userData: {
				email: "",
				password: "",
			},
			nums: 50,
		};
	},
	components: {
		ViewLink,
		ViewFile,
		ViewImage,
		ViewNotes,
		DeleteModal,
		Shimmer,
	},
	validations() {
		return {
			showDetails: {
				title: {
					required,
					maxLength: maxLength(124),
				},

				notes: {
					required: requiredIf(() => this.showDetails.assetType === "5"),
				},
				link: {
					required: requiredIf(() => this.showDetails.assetType === "6"),
					alpha: helpers.regex(
						"alpha",
						/^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\S+)?$/
					),
				},
			},
		};
	},
	computed: {
		tabText() {
			const tab = this.selectedTab;
			switch (tab) {
				case 1:
					return "video";
				case 2:
					return "ppt";
				case 3:
					return "image";
				case 4:
					return "pdf";
				case 5:
					return "note";
				case 6:
					return "link";
			}
		},
		isCreation() {
			return this.$route.name === "coursecreation";
		},
	},
	methods: {
		selectAsset(asset) {
			if (this.isCreation) {
				this.selectedAssetID = asset.assetID;
				this.$emit("asset-selected", asset);

				if (this.hideView) {
					if (asset.assetType === "4" || asset.assetType === "2") {
						this.openPdf(asset);
					} else if (asset.assetType === "8") {
						window.open(asset.asset, "_blank");
					} else {
						this.editOrViewAsset(asset);
					}
				}
			}
		},
		deleteFile() {
			this.showDetails.assetThumbnail = null;
			this.assetThumbnail = null;
		},
		getMethod() {
			this.$emit("handle-get");
		},
		async saveEditedAsset(modalName) {
			this.$v.$touch();

			if ((this.editFile || this.editImage) && !this.showDetails.asset) {
				this.errorFile = true;
				return;
			}

			if (!this.$v.$invalid) {
				this.showLoader = true;
				try {
					let payload = {
						title: this.showDetails.title,
						assetType: this.showDetails.assetType,
						assetID: this.showDetails.assetID,
						tags: JSON.stringify(this.showDetails.tags),
					};

					if (this.showDetails.link) {
						payload.link = this.showDetails.link;
					}
					if (this.fileObject) {
						payload.asset = this.fileObject;
					}
					if (
						this.showDetails.notes &&
						this.showDetails.notes !== "undefined"
					) {
						payload.notes = this.showDetails.notes;
					}
					if (
						this.showDetails.assetType == "1" &&
						this.assetThumbnail !== null
					) {
						payload.assetThumbnail = this.assetThumbnail;
					} else if (
						this.assetThumbnail === null &&
						!this.showDetails.assetThumbnail
					) {
						payload.assetThumbnail = {
							uploadType: "4",
							path: null,
						};
					}

					const response = await postAsset(payload, "put");
					if (response.status == 200) {
						this.showLoader = false;
						this.fileObject = null;
						this.$emit("handle-get");
						this.closeModal(modalName);
						this.$nextTick(() => {
							this.successToast("Asset updated successfully!");
						});
					} else {
						this.showLoader = false;
						this.errorToast("Error adding Asset!");
					}
				} catch (e) {
					this.showLoader = false;
					this.errorToast("Error adding Asset!");
				}
			}
		},

		handleAssetClick(asset, index) {
			if (this.isCreation) {
				this.selectAsset(asset);
			} else {
				if (asset.assetType === "2" || asset.assetType === "4") {
					this.openPdf(asset);
				} else if (asset.assetType === "8") {
					window.open(asset.asset, "_blank");
				} else {
					this.editOrViewAsset(asset, index);
					this.editAsset = false;
					this.editFile = false;
					this.editImage = false;
					this.editNotes = false;
				}
			}
		},
		openPdf(asset) {
			const assetLink = asset.asset;
			if (assetLink) {
				const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
					asset.asset
				)}&embedded=true`;
				window.open(googleViewerUrl, "_blank");
			}
		},
		getThumbnail(file) {
			this.assetThumbnail = file;
		},
		fileUploaded(file) {
			const assetType = parseInt(this.showDetails.assetType);
			const isValidFileType =
				(assetType === 1 &&
					[".mp4", ".mov", ".webm"].some((ext) =>
						file.fileName.endsWith(ext)
					)) ||
				(assetType === 2 &&
					[".ppt", ".pptx"].some((ext) => file.fileName.endsWith(ext))) ||
				(assetType === 3 &&
					[".png", ".jpg", ".jpeg"].some((ext) =>
						file.fileName.endsWith(ext)
					)) ||
				(assetType === 4 &&
					[".pdf", ".txt"].some((ext) => file.fileName.endsWith(ext))) ||
				(assetType === 8 &&
					[".zip"].some((ext) => file.fileName.endsWith(ext)));

			if (!isValidFileType) {
				this.errorToast("Invalid file type");
				return;
			}

			if (file) {
				if (assetType === 3) {
					this.showDetails.asset = URL.createObjectURL(file.sourceKey);
				} else {
					this.showDetails.asset = file.fileName;
				}
				this.fileObject = file.sourceKey;
			}
		},

		async deleteAsset(modalName) {
			if (this.viewFile || this.viewImage || this.viewLink || this.viewNotes)
				modalName = this.modalName;
			this.showLoader = true;
			try {
				let payload = {
					assetID: this.showDetails.assetID,
					assetLibrary: true,
				};

				const response = await postAsset(payload, "delete");
				if (response.status == 200) {
					this.successToast("Asset deleted successfully");
					this.showLoader = false;
					this.showDelete = false;
					this.closeModal(modalName);
					this.$emit("handle-get");
				} else {
					this.showLoader = false;
					this.errorToast("Error deleting Asset!");
				}
			} catch (e) {
				this.showLoader = false;
				this.errorToast("Error deleting Asset!");
			}
		},
		closeModal(modalName) {
			this[modalName] = false;
			this.assetID = null;
		},

		changeVal(val, modalName) {
			this[val] = true;
			if (val == "delete") {
				this.showDelete = true;
				this.modalName = modalName;
			} else if (val == "deleteImage") {
				this.showDetails.asset = "";
			}
		},

		editOrViewAsset(asset, index) {
			this.editedIndex = index;
			this.errorFile = false;
			this.thumbnailPresent = false;

			this.showDetails = JSON.parse(JSON.stringify(asset));

			if (asset.assetType == "6") {
				this.viewLink = true;

				if (!this.selectedAssetID) {
					this.editAsset = true;
				}
			} else if (asset.assetType == "3") {
				this.viewImage = true;
				if (!this.selectedAssetID) {
					this.editImage = true;
				}
			} else if (asset.assetType == "5") {
				this.viewNotes = true;
				if (!this.selectedAssetID) {
					this.editNotes = true;
				}
			} else {
				this.viewFile = true;
				if (!this.selectedAssetID) {
					this.editFile = true;
				}
			}
		},
	},
};
